import React, { useState, useEffect } from 'react'
import AdminHeader from '../../components/Header/AdminHeader'
import AdminSideBar from '../../components/SideBar/AdminSideBar'
import AdminFooter from '../../components/Footer/AdminFooter'
import eventmanageStyle from './EventManagementPage.module.css'
import { Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { CheckPicker, VStack } from 'rsuite';
import { FaEnvelopeOpenText } from 'react-icons/fa';
import BackBar from '../../components/BackBar/BackBar';
import Swal from 'sweetalert2';

export default function EventManagementPage() {
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [schools, setSchools] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]); // Schools filtered by selected ones
  const [selectedSchools, setSelectedSchools] = useState([]);
  const [selectedFromYear, setSelectedFromYear] = useState(""); // Store the selected from year
  const [selectedToYear, setSelectedToYear] = useState("");
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    // Fetch the data from your PHP API
    const fetchSchools = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_cordinator_event_data_admin.php`);
        const data = await response.json();
        if (data.success) {
          setEvents(data.users);
          setFilteredEvents(data.users)
        }
        const response1 = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_cordinator_school_data.php`);
        const data1 = await response1.json();
        if (data1.success) {
          setSchools(data1.users);
        }

      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSchools();
  }, []);

  const currentYear = new Date().getFullYear();
  const fromyears = [];
  for (let year = 2022; year <= currentYear; year++) {
    fromyears.push(year);
  }

  const toyears = [];
  for (let year = 2022; year <= currentYear; year++) {
    toyears.push(year);
  }

  // Handle the change in the multi-select dropdown
  const handleSchoolSelectChange = (event) => {
    const selectedOptions = Array.from(event.target.selectedOptions, option => option.value);
    setSelectedSchools(selectedOptions);

    if (selectedOptions.includes("All")) {
      // If "All" is selected, show all schools
      setFilteredEvents(events);
    } else {
      // Otherwise, filter schools by the selected schools
      // console.log(selectedOptions, 'selec');
      const filtered = events.filter(event => selectedOptions.includes(event.school_name));
      setFilteredEvents(filtered);
    }
  };

  // Effect to handle "To Year" reset or filtering based on "From Year"
  useEffect(() => {
    if (selectedFromYear && selectedToYear) {
      setFilteredEvents(filterSchools());
    }
  }, [selectedFromYear, selectedToYear]);
  // Handle "From Year" change
  const handleFromYearChange = (e) => {
    setSelectedFromYear(Number(e.target.value));
  };

  // Handle "To Year" change
  const handleToYearChange = (e) => {
    setSelectedToYear(Number(e.target.value));

    setFilteredEvents(filterSchools());
  };

  const filterSchools = () => {
    if (!selectedFromYear || !selectedToYear) {
      return events; // If either "From Year" or "To Year" is not selected, return all schools
    }
    return events.filter((event) => {
      const schoolYear = new Date(event.event_end_date).getFullYear();
      return schoolYear >= selectedFromYear && schoolYear <= selectedToYear;
    });
  };

  // Handle search input change
  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchTerm(searchValue);

    if (searchValue === '') {
      setFilteredEvents(events);
    } else {
      const filtered = events.filter(event => {
        // Safely access properties with optional chaining and provide fallback empty strings
        const eventName = event?.event_name?.toLowerCase() || '';
        const orgName = event?.organization_name?.toLowerCase() || '';
        const coordinatorName = `${event?.f_name || ''} ${event?.l_name || ''}`.toLowerCase().trim();

        return (
          eventName.includes(searchValue) ||
          orgName.includes(searchValue) ||
          coordinatorName.includes(searchValue)
        );
      });
      setFilteredEvents(filtered);
    }
  };

  // Function to check if event is within three weeks of end date
  const isWithinThreeWeeks = (endDate) => {
    const eventEndDate = new Date(endDate);
    const currentDate = new Date();
    const threeWeeksInMs = 21 * 24 * 60 * 60 * 1000; // 21 days in milliseconds
    return eventEndDate.getTime() - currentDate.getTime() <= threeWeeksInMs;
  };

  // Function to handle consolidated orders API call
  const handleConsolidatedOrders = async (eventId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_consolidated_orders.php?event_id=${eventId}`);
      const data = await response.json();

      if (data.success) {
        Swal.fire({
          title: 'Success!',
          text: 'Consolidated orders generated successfully',
          icon: 'success',
          confirmButtonText: 'OK'
        });
      } else {
        throw new Error(data.message || 'Failed to generate consolidated orders');
      }
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: error.message || 'Failed to generate consolidated orders',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }
  };

  if (isLoading) {
    return <div></div>; // Show loading state while fetching data
  }

  // DataTable columns configuration
  const columns = [
    {
      name: 'Event Date',
      selector: row => `${row.event_start_date} - ${row.event_end_date}`,
      sortable: true,
      minWidth: '120px',
    },
    {
      name: 'Event Name',
      selector: row => row.school_name,
      sortable: true,
      minWidth: '120px',
      cell: row => (
        <Link to={`/EventManagementDetailsPage/${row.tbl_event_id}`} className="text-primary text-start">
          {row.event_name}
        </Link>
      ),
    },
    {
      name: 'School/Organization',
      selector: row => row.school_name,
      sortable: true,
      minWidth: '120px',
    },
    {
      name: 'Coordinator',
      selector: row => row.cordinator_name,
      sortable: true,
      minWidth: '120px',
    },
    {
      name: 'Ordering Window Date',
      selector: row => row.event_order_date,
      sortable: true,
      minWidth: '120px',
    },
    {
      name: 'Approval Date',
      selector: row => row.approved_date,
      sortable: true,
      minWidth: '160px',
    },
    {
      name: 'Event Link',
      selector: row => row.event_link,
      sortable: true,
      minWidth: '300px',
      cell: row => (
        <Link to={`/${row.event_link}`} className="text-primary text-start" style={{ whiteSpace: 'wrap', textAlign: 'left' }}>
          {row.event_link}
        </Link>
      ),
    },
    /* {
        name: 'Consolidated Orders',
        minWidth: '160px',
        cell: row => {
          const isEnabled = isWithinThreeWeeks(row.event_end_date);
          return (
            <button
              className={`btn ${isEnabled ? 'btn-primary' : 'btn-secondary'}`}
              onClick={() => isEnabled && handleConsolidatedOrders(row.tbl_event_id)}
              disabled={!isEnabled}
              style={{
                padding: '5px 10px',
                fontSize: '12px',
                borderRadius: '4px',
                cursor: isEnabled ? 'pointer' : 'not-allowed',
                opacity: isEnabled ? 1 : 0.6
              }}
            >
              Generate Orders
            </button>
          );
        },
      }, */
    {
      name: 'Consolidated Orders',
      minWidth: '160px',
      cell: row => {
        return (
          <button
            className="btn btn-primary"
            onClick={() => handleConsolidatedOrders(row.tbl_event_id)}
            style={{
              padding: '5px 10px',
              fontSize: '12px',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Generate Orders
          </button>
        );
      },
    },
  ];

  // Custom styles for the DataTable
  const customStyles = {
    table: {
      style: {
        backgroundColor: '#FFFFFF',
        border: 'none',
        borderRadius: '0px',
        borderCollapse: 'collapse',
        borderSpacing: 0,
      },
    },
    headRow: {
      style: {
        backgroundColor: '#FFFFFF',
        borderBottom: 'none',
        minHeight: '40px',
        borderCollapse: 'collapse',
      },
    },
    headCells: {
      style: {
        font: 'normal normal 600 10px/16px Poppins',
        letterSpacing: '0px',
        color: '#707070',
        whiteSpace: 'normal',
        textAlign: 'left',
        padding: '10px 5px',
        border: '1px solid #dee2e6',
        borderCollapse: 'collapse',
        justifyContent: 'center',
        overflow: 'visible',
        minWidth: '220px !important',
      },
    },
    sortIcon: {
      style: {
        position: 'absolute !important',
        right: '8px !important',
        top: '50%',
        transform: 'translateY(-50%)',
      },
    },
    rows: {
      style: {
        minHeight: '32px',
        fontSize: '10px',
        fontFamily: 'Poppins',
        fontWeight: 400,
        borderCollapse: 'collapse',
        color: '#707070',
        '&:not(:last-of-type)': {
          borderBottomStyle: 'none',
        },
      },
    },
    cells: {
      style: {
        font: 'normal normal 400 10px/24px Poppins',
        letterSpacing: '0px',
        color: '#707070',
        whiteSpace: 'nowrap',
        textAlign: 'left',
        padding: '5px',
        border: '1px solid #dee2e6',
        borderCollapse: 'collapse',
        justifyContent: 'center',
        minWidth: '220px !important',
      },
    },
    pagination: {
      style: {
        borderTop: '1px solid #dee2e6',
        paddingTop: '15px',
        font: 'normal normal 400 12px/18px Poppins',
      },
      pageButtonsStyle: {
        color: '#001B64',
        fill: '#001B64',
      },
    },
  };

  return (
    <>
      <AdminHeader />
      <div className={eventmanageStyle.eventmanagementpage} style={{ minHeight: '700px' }}>
        <div className='container'>
          <div className='row mb-4'>
            <div className='col-xl-12'>
              <BackBar />
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-3'>
              <AdminSideBar />
            </div>
            <div className="col-lg-9">
              <div className={eventmanageStyle.eventmanagementBody}>
                <div className={eventmanageStyle.eventmanagementPartone}>
                  <div className="row">
                    <div className='col-lg-8'>
                      <div className='row'>
                        <div className='col-lg-3'>
                          <label className={`${eventmanageStyle.emlabel} form-label`}>School/Org Name</label>
                        </div>
                        <div className='col-lg-8'>
                          <select className={`${eventmanageStyle.emformSelect} form-select mb-2`} multiple value={selectedSchools} onChange={handleSchoolSelectChange}>
                            <option value="All">All</option>
                            {schools.length > 0 ? (
                              schools.map((school, index) => (
                                <option key={index} vlaue={school.school_name} selected>{school.school_name}</option>
                              ))
                            ) : (
                              <option selected>-No Data Available-</option>
                            )}
                          </select>
                        </div>





                      </div>
                    </div>
                    <div className='col-lg-4'>

                      <div className='row gx-3 mb-2'>
                        <div className='col-lg-2'>
                          <label className={`${eventmanageStyle.emlabel} form-label`}>Year:</label>
                        </div>
                        <div className="col-lg-5">
                          <select className={`${eventmanageStyle.asformSelect} form-select mb-2`} onChange={handleFromYearChange}>
                            <option value="">From</option>
                            {fromyears.length > 0 ? (
                              fromyears.map((year, index) => (
                                <option key={index} value={year}>
                                  {year}
                                </option>
                              ))
                            ) : (
                              <option selected>-No Data Available-</option>
                            )}
                          </select>
                        </div>
                        <div className="col-lg-5">
                          <select className={`${eventmanageStyle.asformSelect} form-select mb-2`} onChange={handleToYearChange}>
                            <option value="">To</option>
                            {toyears.length > 0 ? (
                              toyears.map((year, index) => (
                                <option key={index} value={year}>
                                  {year}
                                </option>
                              ))
                            ) : (
                              <option selected>-No Data Available-</option>
                            )}
                          </select>
                        </div>
                      </div>

                      <div className='row'>
                        <div className='col-lg-3'>
                          <label className={`${eventmanageStyle.emlabel} form-label`}>Search:</label>
                        </div>
                        <div className='col-lg-9'>
                          <input type="text" className={`${eventmanageStyle.emformControl} form-control`}
                            placeholder='Search by event name, school/organization, or coordinator'
                            value={searchTerm} onChange={handleSearch}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={eventmanageStyle.eventmanagementParttwo}>
                  <DataTable
                    columns={columns}
                    data={filteredEvents}
                    pagination
                    paginationPerPage={5}
                    paginationRowsPerPageOptions={[5, 10, 15, 20]}
                    highlightOnHover
                    striped
                    responsive
                    customStyles={customStyles}
                    progressPending={isLoading}
                    noDataComponent={<div style={{ padding: '10px', textAlign: 'center', color: '#707070', fontFamily: 'Poppins', fontSize: '12px' }}>No Data Available</div>}
                    sortIcon={<span style={{ paddingLeft: '5px' }}>▼</span>}
                    sortIconRight
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AdminFooter />
    </>
  )
}